import { render, staticRenderFns } from "./ClassroomAllocationEditor.vue?vue&type=template&id=1d2db431&scoped=true&"
import script from "./ClassroomAllocationEditor.vue?vue&type=script&lang=js&"
export * from "./ClassroomAllocationEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomAllocationEditor.vue?vue&type=style&index=0&id=1d2db431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2db431",
  null
  
)

export default component.exports